import BooksApi from './books.api';
import ProjectsApi from './projects.api';
import PhotosApi from './photos.api';
import PackagesApi from './packages.api';
import UsersApi from './users.api';
import ChaptersApi from './chapters.api';
import VersionsApi from './versions.api';
import RatingsApi from './ratings.api';
import QuestionnairesApi from './questionnaires.api';
import InterviewsApi from './interviews.api';
import PricesApi from './prices.api';
import PromptsApi from './prompts.api';
import UpgradeRequestsApi from './upgradeRequests.api';

const API = {
  Books: BooksApi,
  Projects: ProjectsApi,
  Photos: PhotosApi,
  Packages: PackagesApi,
  Users: UsersApi,
  Chapters: ChaptersApi,
  Versions: VersionsApi,
  Ratings: RatingsApi,
  Questionnaires: QuestionnairesApi,
  Interviews: InterviewsApi,
  Prices: PricesApi,
  Prompts: PromptsApi,
  UpgradeRequests: UpgradeRequestsApi,
};

export default API;
